import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var reversibleIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.77 12.84H3.61L9.93 6.6a5.89 5.89 0 0 1 7.68-.48 1 1 0 0 0 1.3-.12l.41-.41a7.4 7.4 0 0 0-10.44-.1l-6.09 6V8.85a1 1 0 0 0-1-1h-.5l-.06 6.44 6.49.06v-.5a1 1 0 0 0-.95-1.01ZM16.3 9.9v.5a1 1 0 0 0 1 1h3.16l-6.16 6a6.2 6.2 0 0 1-3.79 1.82 5.84 5.84 0 0 1-4-1.18 1 1 0 0 0-1.3.08l-.42.41a7.39 7.39 0 0 0 5.2 2.21H10a7.37 7.37 0 0 0 5.17-2.12l6.08-6v2.64a1 1 0 0 0 1 1h.5l.03-6.26Z",
  fill: "currentColor"
}));

export { reversibleIcon as default };
//# sourceMappingURL=reversibleIcon.js.map
